<template>
  <div class="block-wrap block-specification" style="padding: 10px">
    <div v-for="(s, sindex) in specifications" :key="sindex">
      <el-form class="title-bg" ref="skuForm" :model="s" inline>
        <span style="font-size: 14px;">{{sindex === 0 ? '主规格：' : '规格名：'}}</span>
        <template>
          <el-input
            v-if="s.renderType && s.renderType === 'input'"
            style="width: 140px"
            v-model="s.name"
            @blur="changeSpec"
          ></el-input>
          <el-select
              v-if="s.renderType && s.renderType === 'select'"
              v-model="s.propId"
              style="width: 140px"
              filterable
              @change="(val) => handleSpecNameChanged(val,sindex)"
          >
              <template v-for="(op) in s.renderOptions">
                <el-option 
                  :key="op.attributeId" 
                  :label="op.attributeName" 
                  :value="op.attributeId" 
                  :disabled="specifications.findIndex(i => i.propId === op.attributeId) != -1"
                />
              </template>
          </el-select>
        </template>
        <el-button
          v-if="!s.isMainSaleAttr"
          style="float: right"
          type="link" @click="removeSpName(sindex)">删除
        </el-button>
      </el-form>
      <!-- <div v-if="showAddSkuTips && sindex === 0 && !isGroupPuhuo" class="add-sku-tips">
        <div>如需添加新的规格值,请至<el-link @click="changeToBase">【基础资料】</el-link>进行添加</div>
        <span @click="handleNoTips" class="tips-btn">不再提示</span>
      </div> -->
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left: 10px">规格值：</div>
        <vue-draggable
          class="specification-value-flex"
          v-model="specifications[sindex].values"
          filter=".drag-ignore_item"
          handle=".drag-icon-wrap"
          :group="{ name: s.propId, pull: 'clone', put: false }"
          :animation="500"
        >
          <div v-for="(v, vi) in specifications[sindex].values" :key="v.valueKey" class="specification-value-flex_item">
            <el-form ref="specFormRef" :key="vi" :model="v" inline>
              <el-form-item prop="propValueId" :rules="genFormItemValueRule(s, v, vi)">
                <div class="del-input-wrap">
                  <el-select
                      v-if="v.renderType === 'select'"
                      v-model="v.propValueId"
                      filterable
                      @change="(val) => handleSpecValueChanged(val,sindex,vi)"
                  >
                      <template v-for="(op) in v.renderOptions">
                        <el-option 
                          :key="op.attributeValueId" 
                          :label="op.attributeValue" 
                          :value="op.attributeValueId" 
                          :disabled="specifications[sindex].values.findIndex(i => i.propValueId === op.attributeValueId) != -1"
                        />
                      </template>
                  </el-select>
                  <el-input
                    v-else
                    :ref="`${sindex}-${vi}`"
                    placeholder="请输入"
                    class="specification-value-flex_input"
                    @keyup.enter.native="e => valueEnter(sindex, vi)"
                    @change="(val) => handleSpecValueChanged(val,sindex,vi)"
                    v-model="v.propValueId"
                  >
                  </el-input>
                  <el-checkbox
                    style="margin-left: 8px"
                    v-model="v.checked"
                    @change="onChangeCheckbox"
                    :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1"
                  ></el-checkbox>
                  <div @click="removeSpValue(sindex, vi, v)" class="del-btn">
                    <i class="el-icon-close" />
                  </div>
                  <drag-item-content></drag-item-content>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div
            v-if="specifications[sindex].values.length <= specSingleLimit" 
            class="specification-value-flex_item drag-ignore_item"
          >
            <el-button @click="addSpValue(sindex)" type="link">添加规格值</el-button>
          </div>
        </vue-draggable>
        <!-- <div class="tips ft-12 ml-70" v-if="sindex === 0" style="color: #ccc">
          <span
            >默认取商品第一张主图，买家选择不同规格会看到对应规格图片，图片大小不超过2M，长宽比为1:1，建议尺寸：800 x
            800像素，建议格式：png，jpg，jpeg格式</span
          >
        </div> -->
      </div>
    </div>
    <div v-show="specifications.length < maxSpecNumLimit"  class="title-bg">
      <el-button @click="handleAddSpName">添加商品规格</el-button>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import { dragItemMixin } from '../../utils/mixins';
import { cloneDeep } from 'lodash';
import { getBytesCount } from '@utils/data';

export default {
  inject: {
    isGroupPuhuo: {
      default: false,
    },
  },
  components: {
    ImgUpload,
  },
  mixins: [dragItemMixin],
  model: {
    prop: 'values',
    event: 'change',
  },
  props: {
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    saleAttrList:{
      type: Array,
      default() {
        return [];
      },
    },
    changeToBase: {
      // 打开基础资料编辑
      type: Function,
      default: () => {},
    },
    specSingleLimit: {
      type: Number, // 最大规格值数量
      default: 10,
    },
    maxSpecNumLimit: {
      type: Number, // 最大规格数量
      default: 3,
    },
    isCheckImg:{
      type:Boolean,
      default: true
    }
  },
  data() {
    return {
      specifications: [],
      showAddSkuTips: true,
      imgErrMsgs: {},
    };
  },
  computed: {},
  watch: {
    values: {
      handler(v) {
        this.specifications = cloneDeep(v);
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    const noTips = localStorage.getItem('noSecTips');
    if (noTips === '1') {
      this.showAddSkuTips = false;
    }
  },
  methods: {
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`];
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm;
      if (nextInputVm) {
        // 聚焦到下一个
        nextInputVm.focus();
      }
    },
    async validate() {
      const specificationValid = await this.validateSpecForm();
      if (!specificationValid) {
        return false;
      }
      return true;
    },
    genFormItemValueRule(specItem, v, vi) {
      let valueValidator = (rule, value, callback) => {
        // if (v.checked) {
          if (value) {
            if(v.renderType === 'select' && !v.renderOptions.find(i => i.attributeValueId == value)){
              return callback(new Error(`规格值不存在，请重新选择规格值！`));
            }
          }
        // }
        callback();
      };

      return [{ required: v.checked, message: '规格值必填' }, {validator: valueValidator }];
    },
    validateSpecForm() {
      const valueForms = this.$refs.specFormRef;
      const skuForms = this.$refs.skuForm || [];
      return new Promise(resolve => {
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
          return false;
        }
        const promiseList = valueForms.concat(Array.isArray(skuForms) ? skuForms : [skuForms]).map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          });
        });
        Promise.all(promiseList)
          .then(results => {
            const allValid = results.every(result => result);
            resolve(allValid);
          })
          .catch(() => {
            console.log('validateSpecForm has Error');
            resolve(false);
          });
      });
      console.log(allpro, '----allpro--')
    },
    genFormItemImgRule(v, specItem, ref) {
      let valueValidator = async (rule, value, callback) => {
        // if (v.checked) {
          const refImg = this.$refs[ref];
          if (v.imageUrl && refImg && refImg[0]) {
            let errMsg = await refImg[0].method_validImage();
            if (errMsg) {
              return callback(new Error(errMsg));
            } else {
              callback();
            }
          }
        // }
        callback();
      };
      return [
        {
          required: true,
          validator: valueValidator,
        },
      ];
    },

    valueInput(v, s) {
      // window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      // this.$emit('fieldChanged');
      this.changeSpec();
    },
    onChangeCheckbox() {
      window.__spcificationCheckbox_changed = true;
      this.$emit('fieldChanged');
    },

    imageUploadSuccess(url, v, sindex, vi) {
      this.checkImgError && this.checkImgError(); // 淘宝用的
      v.imageUrl = url;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('file-upload', url);
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v, sindex, vi) {
      v.imageUrl = '';
      this.checkImgError && this.checkImgError(); // 淘宝用的

      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    handleNoTips() {
      this.showAddSkuTips = false;
      localStorage.setItem('noSecTips', 1);
    },
    // 规格名变更
    handleSpecNameChanged(val,index){
        const { renderOptions } = this.specifications[index];
        let cOptions = renderOptions.find(i => i.attributeId === val)
        let newValues = []
        let name = cOptions.attributeName
        if(cOptions){
            newValues = [{
              checked:true,
              name:name,
              nameKey:name,
              propId:cOptions.attributeId,
              propValueId:null,
              renderType: cOptions.attributeMode === 2 ? 'select' : 'input',
              renderOptions:cOptions.attributeValueInfoList,
              value:'',
              valueKey:''
            }]
            this.specifications[index].values = newValues;
            this.specifications[index].name = name;
            this.specifications[index].nameKey = name;
            this.changeSpec();
        }
    },
    // 规格值变更
    handleSpecValueChanged(val,pindex,cindex){
        let pItem = this.specifications[pindex]
        const { values } = pItem;
        // let cOptions = values[cindex].renderOptions.find(i => i.attributeValueId === val)
        // let value = cOptions.attributeValue
        // pItem.values[cindex].value = value
        // pItem.values[cindex].valueKey = value
        if(values[cindex].renderType === 'input'){
          pItem.values[cindex].value = val
          pItem.values[cindex].valueKey = val
        }else{
          let cOptions = values[cindex].renderOptions.find(i => i.attributeValueId === val)
          let value = cOptions.attributeValue
          pItem.values[cindex].value = value
          pItem.values[cindex].valueKey = value
        }
        this.changeSpec();
    },
    changeSpec(){
        this.$emit('fieldChanged');
        this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
    },
    // 添加规格值
    addSpValue(index) {
      // if (index === 0) voidValue.imageUrl = '';
      const { values } = this.specifications[index];
      const voidValue = this.gernerateDefaultSpecValueItem(index)
      values.push(voidValue);
      // this.specifications[index].values = formatSpecValues(values, cloneDeep(valueItemRule));
      // window.__spcificationImg_changed = voidValue.valueKey // 用于skuList生成时的图片取值规则
      // this.fieldChanged();
    },
    async handleAddSpName() {
        // const specifications = cloneDeep(this.specifications);
        const voidValue = this.gernerateDefaultSpecValueItem()
        let newSpec = {
          checked:true,
          isMainSaleAttr:false,
          name:'',
          nameKey:'',
          propId:null,
          renderOptions:this.saleAttrList,
          renderType:'select',
          structured:false,
          values:[voidValue],
        }
        this.specifications.push(newSpec);
        console.log('this.specifications:',this.specifications)
        return false;
    },
    removeSpName(index){
        this.specifications.splice(index, 1)
        this.changeSpec();
    },
    removeSpValue(sindex, index, v){
      const _copy = [].concat(this.specifications[sindex].values);
      _copy.splice(index, 1);
      this.$set(this.specifications[sindex], 'values', _copy);
      this.changeSpec();
    },
    gernerateDefaultSpecValueItem(index){
      let _renderOptions = []
      let propId = null
      if(typeof index === 'number' ){
        const { renderOptions,propId:selectPropId } = this.specifications[index];
        propId = selectPropId
        let cOptions = renderOptions.find(i => i.attributeId === selectPropId)
        _renderOptions = cOptions && cOptions?.attributeValueInfoList || []
      }
      let voidValue = {
        checked: true,
        name:'',
        nameKey:'',
        propId:propId,
        propValueId:null,
        renderOptions:_renderOptions,
        renderType:'select',
        value: '',
        valueKey: this.$utils.genkey.get('v'),
        imageUrl:'',
      }
      return voidValue
    },
    validSpecifications(){
      let notFillProps = [];
      let requiredProps = this.saleAttrList.filter(i => i.attributeStatus === 3); // 必填属性
      requiredProps.forEach(item => {
        let spec = this.specifications.find(spec => spec.propId === item.attributeId);
        if(!spec){
          notFillProps.push(item.attributeName);
        }
      });
      if(notFillProps.length > 0){
        return notFillProps.join(',') + '为必填属性,请在规格中添加!';
      }
      return ''
    }
  },
};
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #dcdfe6;

  .input-value {
    display: inline-block;
  }
  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
  // ::v-deep .el-input input {
  //   background: #F8F8F8 !important;
  // }
}

.specification-value {
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    // position: relative;
    // top: -16px;
    &_item {
      margin-right: 10px;
      margin-bottom: 15px;
    }
    &_img {
      width: 100%;
      margin-top: 10px;
      position: relative;
    }
    .el-input,
    .el-select {
      width: 160px;
    }
  }
  ::v-deep .el-form-item__error {
    position: relative;
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  .input-remark {
    margin-left: 10px;
  }
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
}
.remarkWrap {
  margin-top: 5px;
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
</style>